var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "common-table",
          attrs: { data: _vm.tableList },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "timestamp",
              label: "Repayment time",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm
                            .moment(row.timestamp * 1000)
                            .format("YYYY.MM.DD HH:mm")
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "loanId", label: "Borrow No.", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "loan-id-link",
                        on: {
                          click: function ($event) {
                            return _vm.goToBorrowDetail(row.loanId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(row.loanId))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "repayAmount",
              label: "Repayment amount",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("big-number", {
                      attrs: { number: row.repayAmount, decimals: 2 },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "td-word-sm" }, [
                      _vm._v("TCash"),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "unitAmount",
              label: "Collateral released",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("big-number", {
                      attrs: { number: row.unitAmount, decimals: 2 },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "td-word-sm" }, [_vm._v("UNIT")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: {
          total: _vm.queryParams.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.pageSize,
        },
        on: {
          "update:total": function ($event) {
            return _vm.$set(_vm.queryParams, "total", $event)
          },
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "pageSize", $event)
          },
          pagination: function ($event) {
            return _vm.getList()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.32rem", "align-items": "end" },
      },
      [_c("div", { staticClass: "spaceLeft" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }